import { Box, Skeleton, Stack } from '@mui/material'
import { Resource } from 'utoniq-ui'

import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

import { FavoriteMemberEditForm } from './FavoriteMemberEditForm'

export type State = {
  artistId: string
  favoriteMemberId: string
  progress: number
  favoriteMember?: {
    favoriteMemberId: string
    name: string
    avatar: string
  }
  updatingMember: boolean
  loading: boolean
  error?: string
}

export type Action = {
  onDrop: () => Promise<Resource | null>
  onSubmit: (values: {
    avatarPath: string | null
    name: string
  }) => Promise<void>
}

export const ConsoleFavoriteMemberEditTemplate: Template<State, Action> = ({
  state,
  onDrop,
  onSubmit,
}) => {
  const { routerPages } = useRouter()
  const { t } = useTranslation('consoleFavoriteMemberEdit')

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <ConsoleBaseLayout
        header={{
          back: true,
          defaultBackPage: routerPages.ConsoleFavoriteMemberSettings,
          title: t('title'),
        }}
      >
        {state.loading ? (
          <FavoriteMemberEditSkeleton />
        ) : (
          <FavoriteMemberEditForm
            onSubmit={onSubmit}
            onDrop={onDrop}
            progress={state.progress}
            isSubmitting={state.updatingMember}
            favoriteMember={state.favoriteMember}
          />
        )}
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}

const FavoriteMemberEditSkeleton: Cell<{}> = () => {
  const { t } = useTranslation('consoleFavoriteMemberEdit')

  return (
    <Stack>
      {/* 画像アップロードエリアのスケルトン */}
      <CellFrame>
        <Box sx={{ position: 'relative' }}>
          <Skeleton variant="text" width={120} height={32} sx={{ mb: 2 }} />
          <Skeleton
            variant="circular"
            width={250}
            height={250}
            sx={{ borderRadius: '50%', mx: 'auto', display: 'block' }}
          />
        </Box>
      </CellFrame>

      {/* メンバー名入力エリアのスケルトン */}
      <CellFrame>
        <Skeleton variant="text" width={100} height={32} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" width="100%" height={56} />
      </CellFrame>

      {/* 登録ボタンのスケルトン */}
      <CellFrame sx={{ py: 5, textAlign: 'center' }}>
        <Skeleton
          variant="rectangular"
          width={244}
          height={48}
          sx={{ borderRadius: 1, mx: 'auto', display: 'block' }}
        />
      </CellFrame>
    </Stack>
  )
}
